<template>
  <th :style="{minWidth: defaultWidth + 'px'}">
    <div class="thead-header">
      <span v-if="header.name" class="thead-header__text" v-text="header.name"></span>
      <span v-if="header.size" class="thead-header__size" v-text="header.size"></span>
      <b-table-filter
        class="thead-header__filter"
        :is-need-to-clear="clearFilter"
        :filter="header.filter"
        @filtered="filterUpdated"
        @clearFilter="clear"
      />
    </div>
  </th>
</template>

<script>
import BTableFilter from '@/components/table/b-table-filter'

export default {
  name: 'b-table-header',
  components: {BTableFilter},
  props: {
    header: {
      type: Object,
      required: true
    },
    clearFilter: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    defaultWidth() {
      return this.header.minWidth ? this.header.minWidth : 70
    }
  },
  methods: {
    convertDate(date) {
      return new Date(date.getTime() - date.getTimezoneOffset() * 60000).toISOString()
    },
    filterUpdated(val) {
      const filters = []
      if (this.header.filter.type === 'date') {
        filters.push({
          name: this.header.filter.field.fromField,
          operator: '<',
          value: val ? this.convertDate(new Date(val)).split('T')[0] : ''
        })
        filters.push({
          name: this.header.filter.field.toFiled,
          operator: '>',
          value: val ? this.convertDate(new Date(val)).split('T')[0] : ''
        })
      } else if (this.header.filter.type === 'dateRange') {
        filters.push({
          name: this.header.filter.field.fromField,
          operator: '>',
          value: val[0] ? this.convertDate(new Date(val[0])).split('T')[0] : ''
        })
        filters.push({
          name: this.header.filter.field.toFiled,
          operator: '<',
          value: val[1] ? this.convertDate(new Date(val[1])).split('T')[0] : ''
        })
      } else {
        filters.push({
          name: this.header.filter.field,
          operator: this.header.filter.operator,
          value: val
        })
      }
      this.$emit('filtered', filters)
    },
    clear() {
      this.$emit('clearFilter')
    }
  }
}

Date.prototype.addDays = function(days) {
  let date = new Date(this.valueOf())
  date.setDate(date.getDate() + days)
  return date
}
</script>

<style lang="scss" scoped>
.thead-header {
  display: flex;
  justify-content: space-between;
  align-items: center;

  &__text {
    white-space: normal;

    & + .thead-header__filter {
      margin-left: 15px;
    }
  }

  &__filter {
    flex: 0 0 auto;
  }

  &__size {
    display: flex;
    flex: auto;
    padding-left: 5px;
    margin-top: -5px;
    margin-bottom: 5px;
    font-size: 0.9rem;
  }
}
</style>
